import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'translations';
import RoundedHeader from 'app/components/base/RoundedHeader';
import { Layout, Flex } from 'app/components/base/Layout';
import config from 'config';

// Imports from subcomponents
import InsuranceCoverage, {
  mapStateToProps as insuranceMapStateToProps,
} from './commons/InsuranceCoverage';
import { mapStateToProps as gratuityMapStateToProps } from './commons/Gratuity';
import { mapStateToProps as upgradesMapStateToProps } from './commons/UpgradesContainer';

import style from './style.css';

export const messages = {
  title: { id: 'BOOK_TRIP.UPGRADES.TITLE' },
};

const mapStateToProps = (state) => {
  const { isGratuityAvailable } = gratuityMapStateToProps(state);
  const { upgrades } = upgradesMapStateToProps(state);
  const { waitingTime } = insuranceMapStateToProps(state);

  return {
    upgrades,
    waitingTime,
    isGratuityAvailable,
  };
};

/**
 * Stub builder implementation for UpgradeYourTrip section component.
 */
export const builder = (UpgradesContainer, Gratuity) => {
  const UpgradeYourTrip = ({
    upgrades,
    waitingTime,
    isGratuityAvailable,
    mobile,
  }) => {
    if (!config.UPGRADE_YOUR_TRIP_SHOW) return null;
    if (!waitingTime && !isGratuityAvailable && !upgrades.length) return null;
    return (
      <Layout className={style.block} direction="column" nowrap>
        <Flex size="noshrink" className={style.header}>
          <RoundedHeader icon={{ family: 'mozio', name: 'trip-upgrade' }}>
            <FormattedMessage {...messages.title} />
          </RoundedHeader>
        </Flex>
        <Flex size="noshrink" className={style.container}>
          <Gratuity mobile={mobile} />
          <InsuranceCoverage />
          <UpgradesContainer mobile={mobile} />
        </Flex>
      </Layout>
    );
  };

  // TODO: move to Flow types
  // UpgradeYourTrip.propTypes = {
  //   upgrades: PropTypes.array,
  //   waitingTime: PropTypes.object,
  //   isGratuityAvailable: PropTypes.bool
  // };

  return connect(mapStateToProps)(UpgradeYourTrip);
};

export default builder;
